import { useFeatureFlagging as useFeatureFlagging$1 } from '@iwt-core-web/feature-flagging';
export { FeatureFlaggingProvider } from '@iwt-core-web/feature-flagging';

/**
 * Legacy `@aviv-trak/feature-flagging` hook surface, backed by the internalized `@iwt-core-web/feature-flagging` context.
 *
 * It keeps the legacy signatures that differ from the new hook (`getFeatureFlag(key)` returns the raw variation value,
 * not a boolean with fallback) and also exposes the new `getExperimentVariant(key, fallbackValue)`.
 *
 * @deprecated The `@aviv-trak/feature-flagging` package will be removed. Migrate to `useFeatureFlagging` from `@iwt-core-web/feature-flagging`.
 */ const useFeatureFlagging = ()=>{
    const { getExperimentVariant, getVariation, isInitialized } = useFeatureFlagging$1();
    return {
        /**
     * Get an experiment value.
     * @param key The experiment key.
     * @param fallbackValue Returned when the experiment cannot be resolved.
     */ getExperimentVariant,
        /**
     * @deprecated Will be removed. Migrate to `getExperimentVariant(key, fallbackValue)`.
     * @returns The experiment variant, or `undefined` when it cannot be resolved.
     */ getFeatureFlag: getVariation,
        /**
     * @deprecated Will be removed. Migrate to `getExperimentVariant(key, fallbackValue)`.
     * Always returns `undefined`: flags are evaluated lazily, there is no bulk flags map anymore.
     */ getFeatureFlags: ()=>undefined,
        /**
     * @deprecated Will be removed. Migrate to `getExperimentVariant(key, fallbackValue)`.
     */ getVariation,
        /**
     * @returns True if the client is initialized.
     */ isInitialized,
        /**
     * @deprecated Will be removed. Migrate to `isInitialized`.
     */ isLoaded: isInitialized
    };
};

export { useFeatureFlagging };
